<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>

    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsInstituicaoCursoSuperior"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actionsInstituicaoCursoSuperior"
          addFilter
          :items="listarEnsinoSuperior"
        >
        </fccTable>
      </div>
    </div>
    <fccModal
      centered
      idModal="editInstituicaoCursoSuperior"
      size="lg"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form
        @submit.prevent="instituicao.id === 0 ? addInstituicao() : editandoInstituicao()"
        autocomplete="off"
      >
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="instituicao.descricao" required
              >Instituição</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-6">
            <fcc-select
              class="mb-4"
              placeholder="Selecione"
              v-model="instituicao.organizacaoacademica"
              :options="organizacaoacademica"
              required
            >
              Organização Acadêmica
            </fcc-select>
          </div>
          <div class="col-sm-6">
            <fcc-select
              labelField="descricao"
              valueField="descricao"
              class="mb-4"
              placeholder="Selecione"
              v-model="instituicao.categoriaadministrativa"
              :options="listarEscolaridade"
              required
            >
              Categoria Administrativa
            </fcc-select>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6"><toggle-button v-model="instituicao.ativo" /> Ativo</div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Instituição Ensino Superior',
      titleModal: '',
      titlePDF: 'Instituição Ensino Superior',
      listarEnsinoSuperior: [],
      listarEscolaridade: [],
      baseUrlGestaoProjetosConcurso: '',
      instituicao: [],
      itemPorPage: '100',
      organizacaoacademica: [
        'Centro Universitário ',
        'Universidade ',
        'Faculdade ',
        'Instituto Federal de Educação, Ciência e Tecnologia ',
        'Instituição Especialmente Credenciada para oferta de cursos lato sensu ',
        'Escola de Governo ',
        'Outros '
      ],

      actionsInstituicaoCursoSuperior: [
        {
          button: true,
          funcaoButton: 'editInstituicaoCursoSuperior',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteInstituicaoCursoSuperior',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      fieldsInstituicaoCursoSuperior: [
        { key: 'id', label: 'ID', sortable: true, active: true },
        { key: 'organizacaoacademica', label: 'Organização', sortable: true, active: true },
        { key: 'descricao', label: 'Descrição', sortable: true, active: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ]
    }
  },
  methods: {
    linstandoInstituicao: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      this.linstandoInstituicaoGenerico()
        .then((response) => {
          this.listarEscolaridade = response
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    linstandoInstituicaoEnsinoSuperior: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlGestaoProjetosConcurso + 'InstituicaoEnsinoSuperior/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listarEnsinoSuperior = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField: function () {
      this.titleModal = 'Adicionar instituição'
      this.instituicao = {}
      this.instituicao.id = 0
      this.instituicao.ativo = true
      this.$root.$emit('bv::show::modal', 'editInstituicaoCursoSuperior')
    },
    editInstituicaoCursoSuperior: function (_, item) {
      this.titleModal = 'Editar instituição'
      this.instituicao = { ...item }
      this.$root.$emit('bv::show::modal', 'editInstituicaoCursoSuperior')
    },
    editandoInstituicao: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlGestaoProjetosConcurso + 'InstituicaoEnsinoSuperior/Alterar',
          this.instituicao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.linstandoInstituicaoEnsinoSuperior()
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editInstituicaoCursoSuperior')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto())
    },
    addInstituicao: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlGestaoProjetosConcurso + 'InstituicaoEnsinoSuperior/Adicionar',
          this.instituicao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.linstandoInstituicaoEnsinoSuperior()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editInstituicaoCursoSuperior')
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
        .finally(this.carregaTexto())
    },
    deleteInstituicaoCursoSuperior: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              this.baseUrlGestaoProjetosConcurso + 'InstituicaoEnsinoSuperior/Excluir/' + item.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.linstandoInstituicaoEnsinoSuperior()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
            .finally(this.carregaTexto())
        }
      })
    }
  },
  mounted: function () {
    this.baseUrlGestaoProjetosConcurso = store.state.baseUrlGestaoProjetos
    this.linstandoInstituicaoEnsinoSuperior()
    this.linstandoInstituicao()
  }
}
</script>
